import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Dialog from "@mui/material/Dialog";
import axios from "axios";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import MDBackdrop from "components/MDBackdrop";
import { useSnackbar } from "notistack";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useMaterialUIController } from "context";
import theme from "assets/theme";
import IconButton from "@mui/material/IconButton";
import Completion from "./Completion";
import { Image } from "antd";
import { allowOnlyAlphanumericAndSpace } from "utils/Constant";
import { getDecodedUserData } from "utils/Constant";
import { getSecureUrl } from "utils/secureDownload";

function PopAddStart(props) {
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const [isDisabled, setIsDisabled] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [isBackdrop, setIsBackdrop] = useState(false);
  const { onClose } = props;
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();

  const [vehicleImageUrl, setVehicleImageUrl] = useState("");
  const [vehicleImageLoading, setVehicleImageLoading] = useState(false);


  const fetchSecureVehicleImage = async (imgPath) => {
    setVehicleImageLoading(true);

    const url = await getSecureUrl(imgPath);

    setVehicleImageUrl(url || "/assets/images/dummy Image.png");

    setVehicleImageLoading(false);
  };


  useEffect(() => {
    const vehicleImgPath = `${vehicles[0]?.vehicle_img}`;
    fetchSecureVehicleImage(vehicleImgPath);

    return () => {
      setVehicleImageUrl((prev) => {
        if (prev && prev.startsWith("blob:")) {
          try {
            URL.revokeObjectURL(prev);
          } catch (e) { }
        }
        return "";
      });
    };
  }, [vehicles[0]?.vehicle_img]);

  const createUser = (tag_id, charger_id, vehicleId, connectorId, reason) => {
    const payload = {
      action: "start",
      chargerId: charger_id,
      vehicleId: vehicleId,
      payload: {
        idTag: tag_id,
        connectorId: Number(connectorId),
      },
      sessionReason: reason,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_BASEURL + "session/transaction",
      data: payload,
      withCredentials: true,

    })
      .then((response) => {
        if (response.data.status) {
          enqueueSnackbar(response.data.message, { variant: "success" });

          window.location.reload();
        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
        }
      })
      .catch((error) => {
        enqueueSnackbar("An error occurred while stopping the charger.", {
          variant: "error",
        });
      });
  };

  const [values, setValues] = useState(props.value);
  useEffect(() => {
    if (props.isDialog) {
      // reset form values
      setValues({
        tag_id: "",
        charger_id: "",
        vehicleId: "",
        connectorId: "",
        reason: "",
      });
      setErrors({});
      setVehicles([]);
    }
  }, [props.isDialog]);

  const handleChange = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!allowOnlyAlphanumericAndSpace(values.tag_id)) {
      setErrors((prev) => ({
        ...prev,
        tag_id: "Only letters and numbers are allowed",
      }));

      return enqueueSnackbar("Invalid Driver ID", {
        variant: "error",
      });
    }
    if (
      !values.tag_id ||
      !values.charger_id ||
      !values.vehicleId ||
      !values.connectorId ||
      !values.reason
    )
      return enqueueSnackbar("Please Fill All The Details !!!", {
        variant: "error",
      });
    if (errors.tag_id || errors.charger_id) {
      return enqueueSnackbar("Please fix validation errors", {
        variant: "error",
      });
    }

    createUser(
      values.tag_id,
      values.charger_id,
      values.vehicleId,
      values.connectorId,
      values.reason
    );
  };

  const handleClose = () => {
    onClose(false);
  };
  const back = () => {
    setIsBackdrop(false);
    onClose(false);
    props.onStateChange(true);
  };

  const getAllVehiclesOfUser = () => {
    axios({
      method: "get",
      url: process.env.REACT_APP_BASEURL + `users/user/${values.tag_id}/vehicles`,
      withCredentials: true,

    })
      .then((response) => {
        if (response.data.success === true) {
          const data = response.data.data;

          setVehicles(data);
        } else {
          setVehicles([]);
        }
      })
      .catch((error) => {
        setVehicles([]);
      });
  };
  useEffect(() => {
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
    }

    if (values.tag_id) {
      getAllVehiclesOfUser();
    } else {
      setVehicles([]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.tag_id]);

  const validateAlphaNumericWithLimit = (value, max = 30) => {
    if (value.length > max) {
      return `Maximum ${max} characters allowed`;
    }
    if (!allowOnlyAlphanumericAndSpace(value)) {
      return "Only letters and numbers are allowed";
    }
    return "";
  };


  return (
    <>
      <Completion
        isDialog={isDisabled}
        onClose={setIsDisabled}
        value={values}
      />
      <MDBackdrop isBackdrop={isBackdrop} />
      <Dialog
        open={props.isDialog}
        onClose={handleClose}
        fullWidth={false}   //  stop stretching
        PaperProps={{
          sx: {
            width: 1000,     //  exact width (adjust if needed)
            borderRadius: "12px",
          },
        }}      >
        <DialogTitle
          style={
            darkMode
              ? {
                backgroundColor: "#202940",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }
              : {
                theme,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }
          }
        >
          <IconButton
            aria-label="delete"
            onClick={back}
            style={darkMode ? { color: "#ffffff" } : theme}
          >
            <ArrowBackIcon />
          </IconButton>
          Start transaction
          <IconButton
            aria-label="delete"
            onClick={handleClose}
            style={darkMode ? { color: "#ffffff" } : theme}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          style={
            darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme
          }
        >
          <MDBox pt={0} pb={0} px={3}>
            <MDBox pt={0}></MDBox>
            <MDBox p={2} component="form" role="form">
              <MDBox p={1}>
                <MDInput
                  type="text"
                  label="Driver ID"
                  name="tag_id"
                  value={values.tag_id}
                  margin="dense"
                  fullWidth
                  inputProps={{ maxLength: 30 }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setValues((prev) => ({ ...prev, tag_id: value }));
                    setErrors((prev) => ({
                      ...prev,
                      tag_id: validateAlphaNumericWithLimit(value),
                    }));
                  }}
                  onBlur={(e) => {
                    const value = e.target.value;
                    setErrors((prev) => ({
                      ...prev,
                      tag_id: validateAlphaNumericWithLimit(value),
                    }));
                  }}
                  error={Boolean(errors.tag_id)}
                  helperText={errors.tag_id}
                  FormHelperTextProps={{
                    sx: {
                      color: errors.tag_id ? "#d32f2f" : "text.secondary",
                      fontSize: "12px",
                      marginLeft: "4px",
                    },
                  }}
                />

              </MDBox>

              <MDBox p={1}>
                <MDInput
                  type="text"
                  label="Charger name / ID"
                  name="charger_id"
                  value={values.charger_id}
                  margin="dense"
                  fullWidth
                  inputProps={{ maxLength: 30 }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setValues((prev) => ({ ...prev, charger_id: value }));
                    setErrors((prev) => ({
                      ...prev,
                      charger_id: validateAlphaNumericWithLimit(value),
                    }));
                  }}
                  onBlur={(e) => {
                    const value = e.target.value;
                    setErrors((prev) => ({
                      ...prev,
                      charger_id: validateAlphaNumericWithLimit(value),
                    }));
                  }}
                  error={Boolean(errors.charger_id)}
                  helperText={errors.charger_id}
                  FormHelperTextProps={{
                    sx: {
                      color: errors.charger_id ? "#d32f2f" : "text.secondary",
                      fontSize: "12px",
                      marginLeft: "4px",
                    },
                  }}
                />

              </MDBox>
              <MDBox p={1}>
                <FormControl fullWidth>
                  <InputLabel id="demo-multiple-name-label">Vehicle</InputLabel>
                  <Select
                    showSearch
                    sx={{
                      height: 50,
                    }}
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    placeholder="Select Vehicle"
                    value={values.vehicleId}
                    name="vehicleId"
                    onChange={handleChange}
                    input={<OutlinedInput label="Vehicle" />}
                  >
                    {vehicles.length > 0 ? (
                      vehicles.map((city, index) => (
                        <MenuItem key={index} value={city._id}>
                          {city.vehicle_img && (
                            <Image
                              src={
                                vehicleImageUrl
                              }
                              width={24}
                              height={24}
                              preview={false}
                              alt="logo"
                            />
                          )}
                          {city.make} {city.model} {city.variant}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No Data</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </MDBox>

              <MDBox p={1}>
                <MDInput
                  type="number"
                  label="Connector ID"
                  value={values.connectorId}
                  name="connectorId"
                  margin="dense"
                  fullWidth={true}
                  onChange={(e) => {
                    const value = e.target.value;
                    handleChange(e);

                    const parsedValue = parseInt(value, 10);
                    if (value !== "" && (parsedValue < 1 || parsedValue > 8)) {
                      enqueueSnackbar(
                        "No of connectors should be between 1 to 8",
                        { variant: "error" }
                      );
                    }
                  }}
                  inputProps={{
                    min: 1,
                    max: 8,
                  }}
                />
              </MDBox>
              <MDBox p={1}>
                <MDInput
                  type="text"
                  label="Start reason"
                  value={values.reason}
                  name="reason"
                  multiline
                  rows={5}
                  placeholder="Enter Reason for Starting the Charger.. "
                  margin="dense"
                  fullWidth={true}
                  onChange={handleChange}
                />
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions
          style={
            darkMode
              ? {
                backgroundColor: "#202940",
                justifyContent: "space-evenly",
                color: "#ffffff",
              }
              : { theme, justifyContent: "space-evenly" }
          }
        >
          <MDButton
            style={{ width: "87%", maxWidth: 320 }}
            variant="gradient"
            color={sidenavColor}
            onClick={handleSubmit}
          >
            START
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default PopAddStart;
